import { ClockIcon } from "@heroicons/react/24/outline";
import useIsMobile from "../utils/useIsMobile";
import useTimer from "../utils/useTimer";
import { useAppContext } from "../AppContextDef";
import useIsTab from "../utils/useIsTab";
import { fontMap } from "../utils/common";
export default function MainCard({
  mainTitle,
  mainClassCss,
  mainTitleCss,
  FirstSection,
  SecondSection,
  formattedTime: formatTime,
}) {
  let isMobile = useIsMobile();
  let isTab = useIsTab();
  const { formattedTime } = useTimer();
  const { selectedLang } = useAppContext();
  let isMobileOrTab = isMobile || isTab;

  const fontFamilyCSS = fontMap[selectedLang?.lang] || "Lato";

  return (
    <div
      style={{
        backgroundImage:
          !isMobileOrTab &&
          "linear-gradient(360deg, rgba(107, 107, 184, 0) 81.6%, rgba(107, 107, 184, 0.1) 100%)",
      }}
      className={
        mainClassCss
          ? mainClassCss
          : "flex flex-col lg:w-3/5 xl:w-1/2 h-full justify-between lg:border lg:border-gray-275 rounded-xl lg:p-5"
      }
    >
      <div className="w-full mt-0">
        <div className="flex flex-1 items-center justify-between">
          <p
            style={{ fontFamily: fontFamilyCSS }}
            className={
              mainTitleCss
                ? mainTitleCss
                : "hidden lg:block text-4xl text-black-200 font-extrabold mb-0"
            }
          >
            {mainTitle}
          </p>

          <div className="hidden lg:block max-w-max">
            <div className="flex flex-row items-center justify-center bg-orange-250 text-white rounded-md p-2">
              <ClockIcon className="w-4 h-4  font-bold" />
              <p className="text-base  mb-0 ml-2 mt-0 font-medium">
                {formatTime ? formatTime : formattedTime}
              </p>
            </div>
          </div>
        </div>
        {FirstSection}
      </div>
      {SecondSection}
    </div>
  );
}
